module.exports = __webpack_public_path__ + "img/blue_eye.a31ef4a9.svg";